import { ComponentProps } from 'react';
import { vars } from 'src/core/themes';
import { ErrorOutlineIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { ButtonWithIcon } from './ButtonWithIcon';

export const ExpireHoldButton = ({
  textContentId,
  iconOnlyMode,
  variant,
  ...props
}: Omit<ComponentProps<typeof ButtonWithIcon>, 'icon'>) => {
  return (
    <ButtonWithIcon
      {...props}
      icon={
        <ErrorOutlineIcon
          withHoverEffect
          fill={
            iconOnlyMode || (variant && variant !== 'regular')
              ? IconsFill.textNegative
              : IconsFill.textInverted
          }
          size={vars.iconSize.m}
        />
      }
      iconOnlyMode={iconOnlyMode}
      variant={variant}
      textContentId={textContentId || ContentId.ExpireHold}
    />
  );
};
